<template>
  <a-modal
    :title="audit ? '报销审批' : '报销详情'"
    class="gufiiguy"
    :visible="is_show"
    style="top: 20px"
    width="50%"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="is_show = false"
  >
    <template slot="footer">
      <a-button type="primary" @click="download" style="float: left"> 导出 </a-button>
      <a-button key="back" @click="is_show = false"> 取消 </a-button>
      <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
      <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
      <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
    </template>
    <div ref="sadsada">
      <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <div class="title">
          <span>基本信息</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="审批标题"
                class="model_span_form"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span>{{ mdl.title }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="审批编号" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="span">{{ mdl.reimbursementCode }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.ccName }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="费用归属部门">
                <span>{{ mdl.subjectionDeptName }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="关联审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span v-for="(item, index) in mdl.applyList" :key="index" class="auditItem">
                  <span @click="handelAudit(item)">{{ item.associateTitle }}</span>
                </span>
              </a-form-model-item>
            </a-col>
             <a-col :span="24">
              <a-form-model-item label="关联采购" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span v-for="(item, index) in mdl.purchaseList" :key="index" class="auditItem">
                  <span @click="handelAudit(item)">{{ item.associateTitle }}</span>
                </span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <!-- <a-row>
					<a-col :span="24">
						<a-form-model-item label="关联审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<span v-for="(item, index) in mdl.associateApply" :key="index" class="auditItem">
								<span @click="handelAudit(item)">{{item.associateTitle}}</span>
							</span>
						</a-form-model-item>
					</a-col>
				</a-row> -->
        </div>
        <div v-for="(item, index) in mdl.reimburseDetails" :key="index">
          <div class="title">
            <span>报销明细{{ index + 1 }}</span>
          </div>
          <div class="content">
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="费用发生日期">
                  <span>{{ mdl.reimburseDetails[index].expenseTime }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="报销类别">
                  <span>{{ typesType[mdl.reimburseDetails[index].types - 1].label }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="报销金额(元)">
                  <span>{{ mdl.reimburseDetails[index].money }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="费用明细" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <span>{{ mdl.reimburseDetails[index].remark }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="电子发票" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <span>{{ mdl.reimburseDetails[index].invoice }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
        </div>
        <div class="title">
          <span>其他信息</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="报销总金额">
                <span>{{ mdl.reimburseMoneyTotal }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="收款账号">
                <span style="font-weight: 700">{{ mdl.name }}</span
                ><span>{{ mdl.bank }}</span
                ><span>{{ mdl.accountNum }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.remark }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="特殊备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.remarkSpec }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <div class="view_path" @click="previewFile(item)" v-for="(item, index) in mdl.attachment" :key="index">
                  {{ item.name }}
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="报销凭证" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <div
                  class="view_path_img"
                  v-for="(item, index) in mdl.vouchers"
                  :key="index"
                  style="display: flex; justify-content: space-between"
                >
                  <div class="view_path_img_margin"></div>
                  <div class="view_path_img_center">
                    <img :src="item.imgUrl" @click="show_img(index, mdl.vouchers)" />
                  </div>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <div class="title" v-if="!audit && recordNumber==1">
          <span>审批记录</span>
        </div>
        <div class="content" v-if="!audit && recordNumber==1">
          <auditModel ref="auditModel"></auditModel>
        </div>
        <preview ref="preview" />
      </a-form-model>
    </div>
    <!-- 撤销提示 -->
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <business-modal ref="modal" @ok="handleOk" />
    <leave-modal ref="leavemodal" @ok="handleOk" :audit="false" />
    <purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" :typeStyle="typeStyle"  :rowId="rowId"/>
    <scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
    <receive-modal ref="receiveModal" @ok="handleOk" :audit="false" />
    <operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
    <service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
    <reimbursement-modal2 ref="reimbursementmodal" @ok="handleOk" :audit="false"/>
    <!-- 详情 -->
    <payMentModal2 ref="paymentmodal" :audit="false" />
    <!-- 详情 -->
    <contractModal ref="contractmodal" :audit="false" />
    <transferModal ref="transferModal" @sure="handleSure" />
    <sealModal ref="sealmodal" @ok="handleOk" :audit="false" />
    <currencyModal ref="currencymodal" @ok="handleOk" :audit="false" />
    <returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
    <car-modal ref="carmodal" @ok="handleOk" :audit="false" />
    <returncar-modal2 ref="returncarmodal" @ok="handleOk" :audit="false" />
    <charge-modal ref="chargemodal" @ok="handleOk" :audit="false" />
    <salaryModal ref="salarymodal" @ok="handleOk" :audit="false" />
    <adjustmentModal ref="adjustmentmodal" @ok="handleOk" :audit="false" />
    <other-modal ref="othermodal" @ok="handleOk" :audit="false" />
    <feedback-modal ref="feedbackmodal" @ok="handleOk" :audit="false" />
  </a-modal>
</template>
<script>
import { downLoadPdf  } from '@/utils/index'
import auditModel from './audit.vue'
import { resolveBlob } from '@/utils/index'
import { axios } from '@/utils/request'
import { previewFileLists } from '@/utils/preview.js'
import { getReimburseApply, auditTask, act_task_audit, reimburse_apply_downlodPdf, modalMap } from '@/api/activiti'
import { getDeptListEnable2 } from '@/api/system'
import preview from '@/components/module/prview'

import BusinessModal from '@/views/activiti/modules/BusinessModal.vue'
import LeaveModal from '@/views/activiti/modules/LeaveModal.vue'
import PurchaseModal from '@/views/activiti/modules/PurchaseModal.vue'
import ScrapModal from '@/views/activiti/modules/ScrapModal.vue'
import receiveModal from '@/views/activiti/modules/receiveModal.vue'
import OperationModal from '@/views/activiti/modules/OperationModal.vue'
import ServiceModal from '@/views/activiti/modules/ServiceModal.vue'
import ReimbursementModal2 from '@/views/activiti/modules/ReimbursementModal2.vue'
import payMentModal2 from '@/views/activiti/modules/payMentModal2.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import returnModal from '@/views/activiti/modules/returnModal.vue'
import carModal from '@/views/activiti/modules/carModal.vue'
import returncarModal2 from '@/views/activiti/modules/returncarModal2.vue'
import chargeModal from '@/views/activiti/modules/chargeModal.vue'
import salaryModal from '@/views/activiti/modules/salaryModal.vue'
import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
import otherModal from '@/views/activiti/modules/otherModal.vue'
import feedbackModal from '@/views/activiti/modules/feedbackModal.vue'
import Watermark from '../../../utils/watermark'
import { download_file_java } from '@/utils/request'
  const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
const deptMap = {}
export default {
  name: 'LeaveModal',
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    BusinessModal,
    LeaveModal,
    PurchaseModal,
    ScrapModal,
    receiveModal,
    OperationModal,
    ServiceModal,
    ReimbursementModal2,
    payMentModal2,
    contractModal,
    transferModal,
    sealModal,
    currencyModal,
    returnModal,
    carModal,
    returncarModal2,
    chargeModal,
    salaryModal,
    adjustmentModal,
    otherModal,
    feedbackModal,
    auditModel
  },
  data() {
    return {
      recordNumber: 0,
      typeStyle: 1,
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      deptTree: [],
      deptMap,
      visible: false,
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      confirmLoading: false,
      mdl: {},
      options: [],
      dateFormat: 'YYYY-MM-DD HH:mm',
      formData: {},
      form: this.$form.createForm(this),
      is_show: false,
      record: '',
      timeout: null,
      rowId: undefined
    }
  },
  created() {
    getDeptListEnable2().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, min)
        this.deptTree.map((d) => {
          if (d.hasOwnProperty('children')) {
            d.children.map((b) => {
              deptMap[b.key] = {
                text: b.title,
              }
              deptMap[d.key] = {
                text: d.title,
              }
            })
          } else {
            deptMap[d.key] = {
              text: d.title,
            }
          }
        })
        this.expandedKeys = data.map((m) => m.parentId)
        this.dataList = data.map((m) => {
          return {
            key: m.deptId,
            title: m.deptName,
          }
        })
      }
    })
  },
  methods: {
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    },
    handelAudit(item) {
      this.typeStyle = 1
      const modal = modalMap[item.associateTypes]
      console.log(modal, 'modal========================')
      this.$refs[modal].show({
        businessKey: item.associateApply,
      })
    },
    download() {
      	//导出
			downLoadPdf('/act/reimburse_apply/downlodPdf?businessKey=' + this.record.businessKey,)
      // reimburse_apply_downlodPdf({
      //   businessKey: this.record.businessKey,
      // }).then((res) => {
      // window.open(exportBaseUrl + '/file/download?path=' + res.data)
      // })
    },
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    }, //预览文件
    async previewFile(file) {
      console.log(file, 'file=======================')
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },

    // //预览文件
    // previewFile(file) {
    //   console.log(file, 'file=========================')
    //   let path = '/' + file.url.split('/')[0] + '/'
    //   console.log(path, 'path=========================')
    //   let fileName = file.url.substring(file.url.indexOf('/') + 1)
    //   console.log(fileName, 'fileName=========================')
    //   axios({
    //     url: `/file/file/download?bucketName=${file.types}&path=${path}&fileName=${fileName}`,
    //     method: 'post',
    //     responseType: 'blob', // 必须要写 // headers: { //  'Content-Type': 'application/json;charset=UTF-8' // }
    //   }).then((res) => {
    //     this.imgUrl = window.URL.createObjectURL(res)
    //     console.log(this.imgUrl, 'this.imgUrl=========================')
    //     resolveBlob({
    //       data: res,
    //       headers: {
    //         'content-disposition': `attachment;filename=${fileName}`,
    //       },
    //     }) //新窗口打开，借用浏览器去打印
    //   }) // window.open(file.preUrl)

    //   // console.log(file)
    //   // window.open(file.preUrl)
    // },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    show(record) {
      this.recordNumber = record.recordNumber
      this.record = record
      // record 是任务 如果只是查看可以只传入一个businessKey
      if (this.audit) {
        this.formData = Object.assign({
          taskId: record.id,
          procInstId: record.procInstId,
          procName: record.processDefName,
          businessKey: record.businessKey,
          procDefKey: record.processDefKey,
          applyer: record.applyer,
        })
      }
      getReimburseApply(record.businessKey).then((res) => {
        if (res.code === 200) {
          const { type } = res.data
          var purchaseList = []
          var applyList = []

          this.mdl = Object.assign(res.data)
					 this.rowId = Object.assign(res.data)

          this.mdl.associatePurchaseApply.forEach(item => {
            if(item.associateTypes == "purchase") {
              purchaseList.push(item)
            } else {
              applyList.push(item)
            }
          })
          Object.assign(this.mdl, {
            purchaseList: purchaseList,
            applyList: applyList

          })
          
          previewFileLists(this.mdl.vouchers).then((res) => {
            this.mdl.vouchers = res
          })

          this.is_show = true
          this.$nextTick(() => {
            Watermark.set('安联云管家', this.$refs.sadsada)
             if(!this.audit && this.recordNumber == 1) {
                 this.$refs.auditModel.show(record)
               }
          })
        }
      })
    },
    handleSubmit(result) {
      this.confirmLoading = true
      const formData = this.formData
      formData.result = result
      auditTask(formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.$emit('ok')
            this.is_show = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
        console.log(this.record.procName)
      }
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
           clearTimeout(this.timeout)
         console.log(this.timeout, 'this.timeout==========================')
          this.timeout = setTimeout(() => {
            //通过审批
           this.actTask()
         }, 1000)
          // this.actTask()
        }
      } else if (this.result == 2) {
        console.log(this.form, 'formformformformformform')
        // if(){}else{}
         clearTimeout(this.timeout)
         console.log(this.timeout, 'this.timeout==========================')
          this.timeout = setTimeout(() => {
            //通过审批
           this.actTask()
         }, 1000)
        // this.actTask()
      }
    },
    actTask() {
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: this.result,
        businessKey: this.record.businessKey,
        comment: this.comment,
        taskDefKey: this.record.taskDefKey

        // taskDefKey: this.taskDefKey
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.is_show = false
        this.is_revocation = false
      })
    },
  },
  watch: {
    /*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-input-disabled {
  color: #000;
  background-color: #fff;
}

/deep/ .ant-select-disabled {
  color: #000;
}

/deep/ .ant-select-selection {
  background-color: #fff;
}

.view_path {
  width: 100%;
  float: left;
  cursor: pointer;
}
// .auditItem {
// 	border-radius: 5px;
// 	background-color: #f8f8f8;
// 	// margin-left: 10px;
// 	color: dodgerblue;
// 	padding: 0;
// }

.auditItem {
  border-radius: 5px;
  background-color: #f8f8f8;
  // margin-left: 10px;
  color: dodgerblue;
  padding: 10px;
  // padding-left: 0;
}
</style>
